import { jsxs, jsx } from 'react/jsx-runtime';
import CloseModalButton from './CloseModalButton.js';
import DontShowAgain from '../../../DontShowAgain/DontShowAgain.js';
import useDontShowAgainMessageRead from '../../../DontShowAgain/useDontShowAgainMessageRead.js';
import Item from './Item.js';
import { createClosedByDontShowAgainEvent } from './utils.js';

/**
Un item di `Modal`.

Visualizza un contenuto che blocca temporaneamente le interazioni con il resto dell'interfaccia.

Si può utilizzare per questi tipi di messaggi:

- Chiedere conferma o fare decisioni
- Fornire delle informazioni
- Completare dei compiti importanti all'interno di un processo

_Nota_: Se la modale non contiene delle azioni (ad es. Salva),
ma contiene ad es. un processo che richiede i pulsanti "Indietro" e "Avanti",
bisogna inserire il pulsante "X" per poterla chiudere.

_Esempio struttura del componente_

```js
<Modal.Item ... >
  <Modal.Header>
    ...
  </Modal.Header>

  <Modal.Body>
    ...
  </Modal.Body>

  <Modal.Footer>
    ...
  </Modal.Footer>
</Modal.Item>
```
*/
function GenericItem({ className = undefined, children = undefined, onClose = undefined, dontShowAgainId = undefined, dontShowAgainMessage = 'Non mostrare più questo messaggio', id, keepAliveWhenHidden = true, }) {
    const messageRead = useDontShowAgainMessageRead(dontShowAgainId, true);
    if (messageRead) {
        if (onClose) {
            onClose(createClosedByDontShowAgainEvent(id, dontShowAgainId));
        }
        return null;
    }
    return (jsxs(Item, { id: id, className: className, keepAliveWhenHidden: keepAliveWhenHidden, children: [onClose && jsx(CloseModalButton, { onClose: onClose }), children, dontShowAgainId && jsx(DontShowAgain, { className: "v2-modal__dontshowagain", id: dontShowAgainId, message: dontShowAgainMessage })] }));
}

export { GenericItem as default };
